module.exports = __webpack_public_path__ + "img/bwyl.2b77ae56.png";